import React, { useEffect, useState } from 'react';

import RiskSummary from '../Charts/Department/RiskSummary';
import ActionStatus from '../Charts/Department/ActionStatus';
import TopRisks from '../Charts/Department/TopRisks';
import Matrix from '../Charts/Department/Matrix';


import { connect } from "react-redux";
import { compose } from "redux";

import { getDepartmentDashboardData } from "../../store/actions/dashboardActions";
import { openOverlay } from "../../store/actions/riskActions";
import { useTranslation } from "react-i18next";



const DepartmentDashboard = (props) => {
  const { t } = useTranslation();
  const {
    openOverlayFN,
    department_id,
    department_dashboard_data,
    getDepartmentDashboardDataFN,
    setDepartmentDashboardData,
  } = props;


    const [isRepExpanded, setIsRepExpanded] = useState(false);
    const [isFinExpanded, setIsFinExpanded] = useState(false);
    const [isOpExpanded, setIsOpExpanded] = useState(false);

    useEffect(() => {
        ////console.log("Use effect rgigered!");
        getDepartmentDashboardDataFN(department_id);
    }, [department_id, getDepartmentDashboardDataFN]);

    useEffect(() => {
        // Update parent state whenever department_dashboard_data changes
        setDepartmentDashboardData(department_dashboard_data);
    }, [department_dashboard_data, setDepartmentDashboardData]);

    //////console.log(department_dashboard_data);

    return (

        <div className="flex flex-col" style={{ minHeight: `calc(100vh - 245px)` }}>
            {/* First Row: Three Equal Columns */}
            <div className="flex flex-grow w-full">


                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">

                    <div className="bg-white text-gray-900 px-4 py-2 flex-none flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">

                        <div className="flex justify-start items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
                                {t("riskCenter.cards.riskSummary")}
                            </h2>
                        </div>

                    </div>

                    <div className="contents">
                        <RiskSummary height={(window.innerHeight - 450) / 2} data={department_dashboard_data.risk_summary} />
                    </div>
                </div>


                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">


                    <div className="bg-white text-gray-900 px-4 py-2 flex-none flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">

                        <div className="flex justify-start items-center gap-1 flex-nowrap overflow-hidden">
                           <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
                                {t("riskCenter.cards.actionStatus")}
                            </h2>
                        </div>


                    </div>

                    <div className="contents">
                        <ActionStatus height={(window.innerHeight - 550) / 2} data={department_dashboard_data.action_status} />
                    </div>


                </div>
                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">

                      <div className="bg-white text-gray-900 px-4 py-2 flex-none flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">

                        <div className="flex justify-start items-center gap-1 flex-nowrap overflow-hidden">
                           <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
                                {t("riskCenter.cards.topRisks")}
                            </h2>
                        </div>

                    </div>

                    <div className="contents p-2">
                        <TopRisks height={(window.innerHeight - 450) / 2} data={department_dashboard_data.top_5_risks} />

                    </div>



                </div>
            </div>

            {/* Second Row: Two Columns (2/3 and [30%]) */}
            <div className="flex flex-grow w-full mt-4">

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    {/* Header (white bg, black text) */}
                    <div className="bg-white text-black px-4 py-2 flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
                            {t("riskCenter.cards.financialRiskDistribution")}
                        </h2>

                        <button
                            onClick={() => setIsFinExpanded(true)}
                            className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 hover:bg-gray-50"
                            title="Expand"
                        >
                            {/* simple expand icon (bottom-left to top-right) */}
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M3 15v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M21 9V3h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M3 21l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M21 3l-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    </div>

                    <div className="contents p-2 pb-0">
                        <Matrix
                            height={(window.innerHeight - 450) / 2}
                            data={department_dashboard_data.fin_matrix}
                            which="future"
                            isExpanded={isFinExpanded}
                            openExpanded={() => setIsFinExpanded(true)}
                            closeExpanded={() => setIsFinExpanded(false)}
                            openOverlayFN={openOverlayFN}
                        />
                    </div>
                </div>

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    {/* Header (white bg, black text) */}
                    <div className="bg-white text-black px-4 py-2 flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
                            Operational Risk Distribution
                        </h2>

                        <button
                            onClick={() => setIsOpExpanded(true)}
                            className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 hover:bg-gray-50"
                            title="Expand"
                        >
                            {/* simple expand icon (bottom-left to top-right) */}
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M3 15v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M21 9V3h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M3 21l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M21 3l-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    </div>

                    <div className="contents p-2 pb-0">
                        <Matrix
                            height={(window.innerHeight - 450) / 2}
                            data={department_dashboard_data.op_matrix}
                            which="future"
                            isExpanded={isOpExpanded}
                            openExpanded={() => setIsOpExpanded(true)}
                            closeExpanded={() => setIsOpExpanded(false)}
                            openOverlayFN={openOverlayFN}
                        />
                    </div>
                </div>

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    {/* Header (white bg, black text) */}
                    <div className="bg-white text-black px-4 py-2 flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">
                        <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
                            {t("riskCenter.cards.reputationalRiskDistribution")}
                        </h2>

                        <button
                            onClick={() => setIsRepExpanded(true)}
                            className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 hover:bg-gray-50"
                            title="Expand"
                        >
                            {/* simple expand icon (bottom-left to top-right) */}
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M3 15v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M21 9V3h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M3 21l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M21 3l-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    </div>

                    <div className="contents p-2 pb-0">
                        <Matrix
                            height={(window.innerHeight - 450) / 2}
                            data={department_dashboard_data.rep_matrix}
                            which="future"
                            isExpanded={isRepExpanded}
                            openExpanded={() => setIsRepExpanded(true)}
                            closeExpanded={() => setIsRepExpanded(false)}
                            openOverlayFN={openOverlayFN}
                        />
                    </div>
                </div>



            </div>

        </div>



    );


};

const mapStateToProps = (state) => {
    console.log("Data", state.dashboard.department_dashboard_data)
    return {

        department_dashboard_data: state.dashboard.department_dashboard_data,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentDashboardDataFN: (department_id) => dispatch(getDepartmentDashboardData(department_id)),
        openOverlayFN: (id) => dispatch(openOverlay(id)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(DepartmentDashboard);


